import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";

export default function Navbar() {
  const { content } = useContent();
  const n = content.navbar || {};
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 0);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top transition-all premium-navbar ${
        isScrolled ? "premium-navbar-scrolled shadow-sm" : "premium-navbar-top"
      }`}
    >
      <div className="container-fluid px-3 px-md-5">
        <Link className="navbar-brand fw-bold premium-brand d-flex flex-column" to="/">
          <span>
            {n.brandName || "Himmelstor"} <span className="text-farm-gold">{n.brandHighlight || "Farm"}</span>
          </span>
          <span className="premium-brand-subtext">Integrated Agricultural Enterprise</span>
        </Link>
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-lg-2">
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/about">About Us</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/products">Products</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/services">Services</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/agro-tourism">Agro-Tourism</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/gallery">Gallery</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/sustainability">Sustainability</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/blog">Blog</Link></li>
            <li className="nav-item"><Link className="nav-link premium-nav-link" to="/contact">Contact</Link></li>
            <li className="nav-item"><Link className="btn premium-cta-btn ms-lg-2" to="/enquiries">Enquire Now</Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
